/* Component Dependencies */
var subPageHeroImageTemplate = require('templates/subPageHeroImage.hbs');
var subPageHeroImageQuickGroupTemplate = require('templates/subPageHeroImage-quickGroup.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'subPageHeroImage',
  template: {
    'subPageHeroImage': subPageHeroImageTemplate,
    'subPageHeroImage-quickGroup': subPageHeroImageQuickGroupTemplate

  },
  bindEvents: function () {
    var _self = this;
    if(_self.$el.length){
      this.registerPhotoGalleryPopup();
      if($('html').hasClass('ie')) {
        $(window).on('load', function() {
          window.loadAllPictures(_self.$el.get(0).querySelectorAll('picture'));
        });
      } 
    }
  },
  /**
  * This function registers Popup for the "view photo gallery" anchor
  */
  registerPhotoGalleryPopup : function() {
    var _self= this;
    var detailsPopup = new Popup({
        selector: '.tile-subpage-hero-image .js-gallery-viewer',
        sourceBlock: '.modal-content',
        fullScreen: true,
        mainClass: 'mi-gallery mi-gallery-full',
        alternateCloseMarkup: true
      });
      detailsPopup.register();
  }
});
